import { memo } from 'react';

import { keysAddress, keysBankDetails, keysGeneral, keysPaymentMethod } from '../../AddBeneficiaryPopup.constants';
import NotificationError from './NotificationError/NotificationError';
import { getMiscKeys, mapKeysToElements } from './StepFour.helpers';
import { messages } from './StepFour.messages';
import { BeneficiaryData, Devider, Header, Root, SectionContent, SectionHeader } from './StepFour.styles';
import { StepFourProps } from './StepFour.types';

const StepFour = memo<StepFourProps>((props) => {
    const { fields = [], formValues, errorMessages, isLoading } = props;

    const elementsGeneral = mapKeysToElements(keysGeneral, formValues, fields);
    const elementsPaymentMethod = mapKeysToElements(keysPaymentMethod, formValues, fields);
    const elementsBankDetails = mapKeysToElements(keysBankDetails, formValues, fields);
    const elementsAddress = mapKeysToElements(keysAddress, formValues, fields);

    const keysMisc = getMiscKeys([...keysGeneral, ...keysPaymentMethod, ...keysBankDetails, ...keysAddress], fields);
    const elementsMisc = mapKeysToElements(keysMisc, formValues, fields);

    return (
        <Root>
            {errorMessages.length > 0 && <NotificationError errorMessages={errorMessages} />}

            <Header>{isLoading ? messages.titleInLoading : messages.title}</Header>

            <BeneficiaryData progress={isLoading}>
                <SectionHeader>{messages.sectionGeneralInfo}</SectionHeader>

                <SectionContent>{elementsGeneral}</SectionContent>

                <Devider />

                <SectionHeader>{messages.sectionPaymentMethod}</SectionHeader>

                <SectionContent>{elementsPaymentMethod}</SectionContent>

                <Devider />

                <SectionHeader>{messages.sectionBankDetails}</SectionHeader>

                <SectionContent>{elementsBankDetails}</SectionContent>

                <Devider />

                <SectionHeader>{messages.sectionAddress}</SectionHeader>

                <SectionContent>{elementsAddress}</SectionContent>

                <Devider />

                <SectionHeader>{messages.sectionMisc}</SectionHeader>

                <SectionContent>{elementsMisc}</SectionContent>
            </BeneficiaryData>
        </Root>
    );
});

export default StepFour;
